import React, { useState, useEffect } from 'react';
import { Scatter } from '@ant-design/plots';
import NoData from '../../custom-components/NoData';

export const GrtScatterPlot = (props) => {

  const [dataSource, setData] = useState([]);

  useEffect(() => {
    asyncFetch();
  }, []);

  const asyncFetch = () => {
    fetch('https://gw.alipayobjects.com/os/antfincdn/aao6XnO5pW/IMDB.json')
      .then((response) => response.json())
      .then((json) => setData(json))
      .catch((error) => {
        console.log('fetch data failed', error);
      });
  };

  const {
    data,
    xField,
    yField,
    circleSize,
    color,
    yAxisText,
    yAxisFontSize,
    yAxisColor,
    yAxisTitleOffset,
    yPosition,
    yTitlePosition,
    xAxisText,
    xAxisFontSize,
    xAxisColor,
    xAxisTitleOffset,
    xPosition,
    xTitlePosition,
    padding,

    setXAxisLabel,
    setYAxisLabel,
    xLabelRotateNum,
    xLabelColor,
    xLabelOpacity,
    yLabelRotateNum,
    yLabelColor,
    yLabelOpacity,
    xLabelOffsetY,
    yLabelOffsetX,
    yAxisType,
    tickCount,
    tickInterval
  } = props



  const config = {
    appendPadding: 10,
    padding,
    data: data ? data : dataSource,
    xField,
    yField,
    shape: 'circle',
    size: circleSize,
    color,
    xAxis: {
      grid: {
        line: {
          style: {
            stroke: '#eee',
          },
        },
      }
    },
    yAxis: {
      type: yAxisType ? 'log' : 'linear',
      position: yPosition,
      title: {
        text: yAxisText,
        autoRotate: false,
        offset: yAxisTitleOffset,
        position: yTitlePosition,
        style: {
          fontSize: yAxisFontSize,
          fill: yAxisColor
        },
      },
      line: {
        style: {
          stroke: '#aaa',
        },
      },
      label: {
        formatter: setYAxisLabel,
        rotate: yLabelRotateNum,
        autoHide: true,
        autoRotate: false,
        offsetX: yLabelOffsetX,
        style: {
          fill: yLabelColor,
          opacity: yLabelOpacity ? yLabelOpacity / 1 : 1
        }
      }
    },
    xAxis: {
      range: [0.03, 0.98],
      tickCount,
      tickInterval,
      position: xPosition,
      title: {
        text: xAxisText,
        autoRotate: false,
        offset: xAxisTitleOffset,
        position: xTitlePosition,
        style: {
          fontSize: xAxisFontSize,
          fill: xAxisColor
        }
      },
      grid: {
        line: {
          style: {
            stroke: '#eee',
          },
        },
      },
      line: {
        style: {
          stroke: '#aaa',
        },
      },
      label: {
        formatter: setXAxisLabel,
        rotate: xLabelRotateNum,
        autoHide: true,
        autoRotate: false,
        offsetY: xLabelOffsetY,
        style: {
          fill: xLabelColor,
          opacity: xLabelOpacity ? xLabelOpacity / 1 : 1
        }
      }
    },
  };

  return <>
    {data && data.length > 0 ? <Scatter {...config} /> : <NoData />}
  </>;
};

